module.exports = __webpack_public_path__ + "static/media/carson.3c9792e8.png";